import { axiosBase, errorHandler } from "./axios";
import { getAccessToken } from "./helper";

const EA_BASE = `/api/v1/event-albums`;

const authHeaders = () => ({ Authorization: `Bearer ${getAccessToken()}` });

export const generateAlbumApi = (selectionId: string) =>
    axiosBase
        .post(`${EA_BASE}/generate`, { selectionId }, { headers: authHeaders() })
        .then((r) => r.data)
        .catch(errorHandler);

export const fetchEventAlbumApi = ({ albumId, pages }: { albumId: string; pages?: boolean }) => {
    const url = `${EA_BASE}/view/${albumId}/${pages ?? false}`;
    return axiosBase
        .get(url, { headers: authHeaders() })
        .then((r) => r.data)
        .catch(errorHandler);
};

export const fetchEventAlbumBySelectionApi = (selectionId: string) =>
    axiosBase
        .get(`${EA_BASE}/by-selection/${selectionId}`, { headers: authHeaders() })
        .then((r) => r.data)
        .catch(errorHandler);

export const updateAlbumPagesApi = (albumId: string, pages: unknown[], pageOrder: string[]) =>
    axiosBase
        .patch(`${EA_BASE}/pages`, { albumId, pages, pageOrder }, { headers: authHeaders() })
        .then((r) => r.data)
        .catch(errorHandler);

export const sendAlbumReviewApi = (albumId: string, expiresInDays?: number) =>
    axiosBase
        .post(`${EA_BASE}/send-review`, { albumId, expiresInDays }, { headers: authHeaders() })
        .then((r) => r.data)
        .catch(errorHandler);

export const customerViewAlbumApi = (payload: {
    identifier?: string;
    reviewToken?: string | null;
    emailOrPhoneNumber?: string;
}) =>
    axiosBase
        .post(`${EA_BASE}/customer/view`, payload)
        .then((r) => r.data)
        .catch(errorHandler);

export const customerApproveAlbumApi = (
    albumId: string,
    opts: {
        reviewToken?: string | null;
        accessCode?: string | null;
        comment?: string;
        func?: string;
    },
) =>
    axiosBase
        .post(`${EA_BASE}/customer/approve`, { albumId, ...opts })
        .then((r) => r.data)
        .catch(errorHandler);

export const fetchAlbumService = (albumId: string) => {
    return axiosBase
        .get(`${EA_BASE}/fetchAlbum/${albumId}`)
        .then((r) => r.data)
        .catch(errorHandler);
};
export const fetchAlbumPageService = (payload: { albumId: string; pageId: string }) => {
    return axiosBase
        .get(`${EA_BASE}/pages/${payload.pageId}`)
        .then((r) => r.data)
        .catch(errorHandler);
};

export const fetchPagesApi = ({ albumId, pageIds }: { albumId: string; pageIds: string[]; }) =>
    axiosBase
        .post(`${EA_BASE}/${albumId}/pages/batch`, { pageIds })
        .then((r) => r.data)
        .catch(errorHandler);

export const createAlbumPage = (payload: { albumId: string }) => {
    return axiosBase
        .post(`${EA_BASE}/album/${payload.albumId}/pages`)
        .then((r) => r.data)
        .catch(errorHandler);
};

export const deleteAlbumPage = (payload: { albumId: string; pageId: string }) => {
    return axiosBase
        .post(`${EA_BASE}/album/${payload.albumId}/pages/${payload.pageId}`)
        .then((r) => r.data)
        .catch(errorHandler);
};

export const saveAlbumPage = ({ pageId, body }: { pageId: string; body: any }) => {
    return axiosBase
        .patch(`${EA_BASE}/pages/${pageId}`, body)
        .then((r) => r.data)
        .catch(errorHandler);
};

export const saveAlbumPages = (
  pages: Array<{
    pageId: string;
    nodes: any;
    backgroundColor?: string;
    backgroundAssetId?: string | null;
    backgroundOpacity?: number;
    label?: string;
    history?: any[];
  }>,
) => {
  return axiosBase
    .patch(`${EA_BASE}/pages/batch`, { pages })
    .then((r) => r.data)
    .catch(errorHandler);
};

export const createBackgroundSasService = ({
    pageId,
    fileName,
}: {
    pageId: string;
    fileName: string;
}) => {
    return axiosBase
        .post(`${EA_BASE}/page/${pageId}/sas`, { fileName })
        .then((r) => r.data)
        .catch(errorHandler);
};

export const getBackgroundReadSasService = (pageId: string) =>
    axiosBase
        .get(`${EA_BASE}/page/${pageId}/background-sas`)
        .then((r) => r.data)
        .catch(errorHandler);

export const getNodeSas = (blobPath: string) => {
    return axiosBase
        .get(`${EA_BASE}/blob/image-sas`, {
            params: { blobPath: encodeURI(blobPath) },
        })
        .then((r) => r.data.resultObject)
        .catch(errorHandler);
};

export const getAlumBackgroundService = ({
    eventId,
    studioId,
    serviceId,
}: {
    eventId: string;
    studioId: string;
    serviceId: string;
}) => {
    return axiosBase
        .get(`${EA_BASE}/get-backgrounds/`, {
            params: {
                eventId,
                studioId,
                serviceId,
            },
        })
        .then((r) => r.data)
        .catch(errorHandler);
};
